import { Box } from '@mui/material';

import { FORTA_BLUE } from '../../../../utils/colors';
import {
  INTRODUCTION_PAGE_SX,
  INTRODUCTION_VIDEO_CONTAINER_SX,
  INTRODUCTION_VIDEO_WRAPPER_SX,
} from '../styles';
import QuestionnaireSectionLabel from './QuestionnaireSectionLabel';
import VideoPlayer from './VideoPlayer';

import type { QuestionnaireIntroductionProps } from '../types';

export default function QuestionnaireIntroduction({ src, poster }: QuestionnaireIntroductionProps) {
  return (
    <>
      <QuestionnaireSectionLabel variant="h5" sx={{ mb: 1.5, color: FORTA_BLUE.primary }}>
        Introduction
      </QuestionnaireSectionLabel>
      <Box sx={INTRODUCTION_PAGE_SX}>
        <Box sx={INTRODUCTION_VIDEO_WRAPPER_SX}>
          <Box sx={INTRODUCTION_VIDEO_CONTAINER_SX}>
            <VideoPlayer src={src} poster={poster} />
          </Box>
        </Box>
      </Box>
    </>
  );
}
